import clsx from 'clsx'
import { CSSProperties, useContext } from 'react'
import Skeleton, { SkeletonProps } from 'react-loading-skeleton'
import { EnTheme } from 'src/enums'
import { ThemeContext } from 'src/providers/ThemeProvider'

const SkeletonWrapper = (props: SkeletonProps) => {
  const { theme } = useContext(ThemeContext)

  return (
    <Skeleton
      inline
      containerClassName={clsx(props.containerClassName, 'leading-none')}
      {...(theme == EnTheme.DARK
        ? {
            style: {
              '--base-color': '#202020',
              '--highlight-color': '#444',
            } as CSSProperties,
          }
        : {})}
      {...props}
    />
  )
}

export default SkeletonWrapper
